import React, { useState, useEffect, useRef } from "react";
import classes from "./CashReciept.module.css";
import api, { BASE_URL, withCompanyId } from "../../../Components/API/Api";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";

import Swal from "sweetalert2";
import crop from "../../../Assets/repoort.png";
import verified from "../../../Assets/verified.svg";

function SalaryStructureSet({ isOpen, onClose, onSuccess, mode = "structure" }) {
  const isAllowanceMode = mode === "allowances";
  const [rows, setRows] = useState([
    { accountId: "", accountDisplay: "", accountCode: "", amount: "", showDropdown: false },
  ]);

  const [reference, setReference] = useState("");
  const navigate = useNavigate();
  const [debitSearch, setDebitSearch] = useState("");
  const [showDebitDropdown, setShowDebitDropdown] = useState(false);
  const [transactionDate, setTransactionDate] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [description, setDescription] = useState("");
  const [debitAccount, setDebitAccount] = useState("");
  const [outstandingAmount, setOutstandingAmount] = useState("");
  const [selectedLoanAccount, setSelectedLoanAccount] = useState("");
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [loanOptions, setLoanOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [paymentTypesLoading, setPaymentTypesLoading] = useState(false);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [supplierLoading, setSupplierLoading] = useState(false);
  const [paymentToLoading, setPaymentToLoading] = useState(false);
  const paymentTypeLower = (selectedPaymentType || "").toLowerCase();
  const [creditAccounts, setCreditAccounts] = useState([]);

  const [totalAmount, setTotalAmount] = useState("");
  const [receiptTypes, setReceiptTypes] = useState([]);
  const [receiptTypesLoading, setReceiptTypesLoading] = useState(false);
  const [paymentSearch, setPaymentSearch] = useState("");
  const [showPaymentDropdown, setShowPaymentDropdown] = useState(false);
  const [expenseOptions, setExpenseOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [paymentModes, setPaymentModes] = useState([]);
  const [receiptType, setReceiptType] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [debitAccountsLoading, setDebitAccountsLoading] = useState(false);
  const [employmentTypes, setEmploymentTypes] = useState([]);
  const [employmentStatuses, setEmploymentStatuses] = useState([]);
  const [employmentLoading, setEmploymentLoading] = useState(false);
  const [taxStations, setTaxStations] = useState([]);
  const [gradeOptions, setGradeOptions] = useState([]);
  const [gradeLoading, setGradeLoading] = useState(false);
  const [stepOptions, setStepOptions] = useState([]);
  const [stepLoading, setStepLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_number: "",
    address: "",
    account_number: "",
    bank_name: "",
    account_name: "",
    wht: "",
    stin: "",
    cac: "",
  });
  const [generatedEmpId, setGeneratedEmpId] = useState("");
  const formRef = useRef(null);
  const [canSave, setCanSave] = useState(false);

  // NEW: fields & verification state for NIN verification
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [nin, setNin] = useState(""); // national identification number
  const [verifyingNin, setVerifyingNin] = useState(false);
  const [verifiedNinImage, setVerifiedNinImage] = useState(null); // url or data URI
  const [lastVerifiedNin, setLastVerifiedNin] = useState(null);

  // --- ADDED: salary structure state ---
  const [grade, setGrade] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [payBasis, setPayBasis] = useState("");
  const [payBasisOptions, setPayBasisOptions] = useState([]);
  const [payBasisLoading, setPayBasisLoading] = useState(false);
  const [basic, setBasic] = useState(0);
  const [allowanceTypes, setAllowanceTypes] = useState([]);
  const [allowanceTypesLoading, setAllowanceTypesLoading] = useState(false);

  // allowance entries have separate `percentage` and `amount`. If percentage is provided,
  // amount is computed as (basic * percentage / 100). If percentage is empty, amount is editable.
  const [allowances, setAllowances] = useState([{ allowanceTypeId: "", percentage: "", amount: 0 }]);

  const [deductions, setDeductions] = useState([{ name: "Tax", amount: 0 }]);
  // inline notification inside modal (e.g., duplicates)
  const [inlineAlert, setInlineAlert] = useState("");
  const [modalAlert, setModalAlert] = useState(null);

  // add allowance row
  const addAllowance = () => {
    setAllowances((prev) => [...prev, { allowanceTypeId: "", percentage: "", amount: 0 }]);
  };

  // add deduction row
  const addDeduction = () => {
    setDeductions((prev) => [...prev, { name: "", amount: 0 }]);
  };

  // remove row (type: 'allowance' | 'deduction', index)
  const removeRow = (type, idx) => {
    if (type === "allowance") {
      setAllowances((prev) => prev.filter((_, i) => i !== idx));
    } else {
      setDeductions((prev) => prev.filter((_, i) => i !== idx));
    }
  };

  // update a row value
  const updateRow = (type, idx, field, value) => {
    if (type === "allowance") {
      setAllowances((prev) =>
        prev.map((r, i) => {
          if (i !== idx) return r;

          // prevent duplicate allowance types
          if (field === "allowanceTypeId") {
            const picked = String(value || "");
            if (picked) {
              const existsElsewhere = prev.some((row, j) => j !== idx && String(row.allowanceTypeId || "") === picked);
              if (existsElsewhere) {
                setInlineAlert("You have already selected this allowance type.");
                return r; // ignore change
              }
              // clear any previous duplicate alert on a valid change
              if (inlineAlert) setInlineAlert("");
            }
          }

          // if updating percentage, normalize input and compute amount from basic
          if (field === "percentage") {
            const cleaned = String(value).replace(/[^0-9.]/g, ""); // allow digits and dot
            const perc = cleaned === "" ? "" : Number(cleaned);
            const base = Number(basic) || 0;
            const computedAmount = perc === "" || isNaN(perc) ? r.amount : Number(((base * perc) / 100).toFixed(2));
            return { ...r, percentage: cleaned === "" ? "" : cleaned, amount: computedAmount };
          }

          // updating amount directly (only allowed when percentage is empty)
          if (field === "amount") {
            const v = value === "" ? "" : Number(value);
            return { ...r, amount: v };
          }

          return { ...r, [field]: value };
        })
      );
    } else {
      setDeductions((prev) => prev.map((r, i) => (i === idx ? { ...r, [field]: field === "amount" ? Number(value) : value } : r)));
    }
  };

  // Recompute allowance amounts when basic salary changes for allowances that have a percentage set
  useEffect(() => {
    const base = Number(basic) || 0;
    setAllowances((prev) =>
      prev.map((r) => {
        if (r.percentage === "" || r.percentage === null || isNaN(Number(r.percentage))) return r;
        const perc = Number(r.percentage);
        return { ...r, amount: Number(((base * perc) / 100).toFixed(2)) };
      })
    );
  }, [basic]);

  // reset the salary structure form
  const resetStructureForm = () => {
    setGrade("");
    setJobTitle("");
    setPayBasis("Monthly");
    setBasic(0);
    setAllowances([{ allowanceTypeId: "", percentage: "", amount: 0 }]);
    setDeductions([{ name: "Tax", amount: 0 }]);
    setModalAlert(null);
    // if using a DOM form reset is still fine but we keep state consistent
    const f = document.getElementById("structureForm");
    if (f) f.reset();
  };

  // save structure (creates salary structure)
  const saveStructure = async () => {
    const grade_id = document.getElementById('empGrade')?.value || "";
    const step_id = document.getElementById('empStep')?.value || "";
    const pay_basic = payBasis || "";
    const basic_salary = Number(basic) || 0;

    const allowance_type = isAllowanceMode ? allowances.map(a => a.allowanceTypeId).filter(Boolean) : [];
    const amount = isAllowanceMode ? allowances.map(a => Number(a.amount) || 0) : [];

    if (isAllowanceMode) {
      const seen = new Set();
      for (const t of allowance_type) {
        const key = String(t);
        if (seen.has(key)) {
          setInlineAlert("Remove duplicate allowance types before saving.");
          return;
        }
        seen.add(key);
      }
    }

    const missingBaseFields = !grade_id || !step_id || !pay_basic || (!isAllowanceMode && !basic_salary);
    const missingAllowanceFields = isAllowanceMode && (allowance_type.length === 0 || amount.some(v => !v));

    if (missingBaseFields || missingAllowanceFields) {
      const message = isAllowanceMode
        ? "Select grade, step, pay basis, and add at least one allowance with amount."
        : "Select grade, step, pay basis, and enter basic salary.";
      Swal.fire({ icon: "error", title: "Missing data", text: message });
      setModalAlert({ type: "error", message });
      return;
    }

    const payload = { grade_id, step_id, pay_basic };
    if (!isAllowanceMode) {
      payload.basic_salary = basic_salary;
    } else {
      payload.allowance_type = allowance_type;
      payload.amount = amount;
    }

      try {
        setIsSaving(true);
        const endpoint = isAllowanceMode ? '/v1/salary_allowance/create' : '/v1/payroll/salary_structure/set';
        const res = await api.post(endpoint, withCompanyId(payload));
      if (res?.data?.status) {
        // close modal, reset the form, and refresh parent table
        if (typeof onClose === "function") onClose();
        resetStructureForm();
        setInlineAlert("");
        if (typeof onSuccess === "function") onSuccess(res?.data);
        Swal.fire({ icon: "success", title: "Saved", text: res?.data?.message || "Salary structure saved successfully." });
        setModalAlert(null);
      } else {
        const msg = res?.data?.message;
        if (msg && typeof msg === 'object') {
          const combined = Object.entries(msg).map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(', ') : v}`).join('; ');
          Swal.fire({ icon: "error", title: "Save failed", text: combined || "Failed to save salary structure." });
          setModalAlert({ type: "error", message: combined || "Failed to save salary structure." });
        } else {
          const fallbackMsg = res?.data?.message || "Failed to save salary structure.";
          Swal.fire({ icon: "error", title: "Save failed", text: fallbackMsg });
          setModalAlert({ type: "error", message: fallbackMsg });
        }
      }
    } catch (err) {
      const msg = err?.response?.data?.message;
      if (msg && typeof msg === 'object') {
        const combined = Object.entries(msg).map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(', ') : v}`).join('; ');
        Swal.fire({ icon: "error", title: "Save failed", text: combined });
        setModalAlert({ type: "error", message: combined });
      } else {
        const fallbackMsg = err?.response?.data?.message || "Could not save salary structure.";
        Swal.fire({ icon: "error", title: "Save failed", text: fallbackMsg });
        setModalAlert({ type: "error", message: fallbackMsg });
      }
    } finally {
      setIsSaving(false);
    }
  };

  // validate required fields (reads DOM values to avoid converting inputs to controlled)
  const validateRequired = () => {
    const requiredIds = [
      "empFirstName", "empLastName", "empGender", "empAddress", "empNin", "empEmail", "empPhone",
      "empDob", "empMarital", "empDept", "empUnit", "empType", "empJobTitle", "empGrade", "empStep",
      "empAppointment", "empSupervisor", "empStatus", "empBank", "empAccount", "empSalary",
      "empKinName", "empKinRel", "empKinPhone", "empKinAddr"
    ];

    const getVal = id => (document.getElementById(id)?.value || "").toString().trim();

    // must have generated id and a photo
    if (!String(generatedEmpId).trim()) { setCanSave(false); return false; }
    if (!verifiedNinImage) { setCanSave(false); return false; }

    for (const id of requiredIds) {
      if (!getVal(id)) { setCanSave(false); return false; }
    }

    setCanSave(true);
    return true;
  };

  // attach listeners to the form so validation runs on user edits/resets; re-run when key values change
  useEffect(() => {
    if (!isOpen) { setCanSave(false); return; }
    const formEl = formRef.current || document.getElementById("empForm");
    if (!formEl) return;

    const onValidate = () => validateRequired();
    formEl.addEventListener("input", onValidate);
    formEl.addEventListener("change", onValidate);
    formEl.addEventListener("reset", onValidate);

    // initial run (useful when generatedEmpId or verifiedNinImage already set)
    onValidate();

    return () => {
      formEl.removeEventListener("input", onValidate);
      formEl.removeEventListener("change", onValidate);
      formEl.removeEventListener("reset", onValidate);
    };
  }, [isOpen, generatedEmpId, verifiedNinImage]);

  // keep handlePrinter as-is
  const handlePrinter = () => {
    const receiptData = {
      reference,
      transactionDate,
      description,
      selectedCurrency,
      selectedPaymentMode,
      debitAccount,
      totalAmount,
      rows,
    };

    navigate("/preview", {
      state: { invoice: receiptData },
    });
  };

  // --- Update outstandingAmount when reference (customer selection) changes ---
  useEffect(() => {
    if (!receiptType?.toLowerCase()?.includes("credit customer")) {
      setOutstandingAmount("");
      return;
    }

    if (!reference) {
      setOutstandingAmount("");
      return;
    }

    const customerObj = customerOptions.find(c => String(c.id) === String(reference));
    const balance = customerObj?.balance ?? 0;
    setOutstandingAmount(String(Number(balance) || 0));
  }, [reference, customerOptions, receiptType]);

  // --- Fetch customers (only when receiptType includes credit customer) ---
  useEffect(() => {
    const fetchCustomers = async () => {
      if (!receiptType?.toLowerCase()?.includes("credit customer")) return;

        try {
          setCustomerLoading(true);
          const res = await api.get('/v1/customer/get');

          if (res.data && Array.isArray(res.data.data)) {
            setCustomerOptions(res.data.data);
          } else {
            setCustomerOptions([]);
          }
        } catch (err) {
          console.error("Error fetching customers:", err);
          setCustomerOptions([]);
        } finally {
          setCustomerLoading(false);
        }
    };

    fetchCustomers();
  }, [receiptType]);

  // --- Fetch loans (when receiptType includes loan repayment) ---
  useEffect(() => {
    const fetchLoanOptions = async () => {
      if (!receiptType?.toLowerCase()?.includes("loan repayment")) return;

      try {
        setPaymentToLoading(true);
        const res = await api.get('/v1/loans');

        if (res.data && Array.isArray(res.data.data)) {
          setLoanOptions(res.data.data);
        } else {
          setLoanOptions([]);
        }
      } catch (err) {
        console.error("Error fetching loans:", err);
        setLoanOptions([]);
      } finally {
        setPaymentToLoading(false);
      }
    };

    fetchLoanOptions();
  }, [receiptType]);

  // --- Fetch employees (when receiptType includes employee payment) ---
  useEffect(() => {
    const fetchEmployeeOptions = async () => {
      if (!receiptType?.toLowerCase()?.includes("employee payment")) return;

      try {
        setPaymentToLoading(true);
        const res = await api.get('/v1/employee/paginated');

        // Handle paginated response: { status, message, data: { current_page, data: [...], ... } }
        if (res.data && res.data.data?.data && Array.isArray(res.data.data.data)) {
          setEmployeeOptions(res.data.data.data);
        } else {
          setEmployeeOptions([]);
        }
      } catch (err) {
        console.error("Error fetching employees:", err);
        setEmployeeOptions([]);
      } finally {
        setPaymentToLoading(false);
      }
    };

    fetchEmployeeOptions();
  }, [receiptType]);

  // --- Fetch payment types ---
  useEffect(() => {
    const fetchPaymentTypes = async () => {
      setPaymentTypesLoading(true);
      try {
        const res = await api.get('/v1/get_type_of_payments', { params: { name: 'payment' } });
        if (res.data && Array.isArray(res.data.data)) {
          setPaymentTypes(res.data.data);
        } else {
          setPaymentTypes([]);
        }
      } catch (err) {
        setPaymentTypes([]);
      } finally {
        setPaymentTypesLoading(false);
      }
    };
    fetchPaymentTypes();
  }, []);

  // --- Fetch suppliers when selectedPaymentType includes supplier ---
  useEffect(() => {
    const fetchSuppliers = async () => {
      const type = (selectedPaymentType || "").toLowerCase().trim();

      if (!type.includes("supplier")) {
        setSupplierOptions([]);
        return;
      }

      setSupplierLoading(true);
      try {
        const res = await api.get('/v1/beneficiary');

        const suppliers = res?.data?.data;
        if (Array.isArray(suppliers)) {
          const options = suppliers.map((s) => ({
            id: s.id,
            name: s.supplier_name || s.name || `Supplier ${s.id}`,
          }));
          setSupplierOptions(options);
        } else {
          setSupplierOptions([]);
        }
      } catch (err) {
        console.error("Error fetching suppliers:", err);
        setSupplierOptions([]);
      } finally {
        setSupplierLoading(false);
      }
    };

    fetchSuppliers();
  }, [selectedPaymentType]);

  // --- Fetch Account Names and Codes ---
  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const res = await api.get('/v1/get-expense-accounts');
        if (res.data && res.data.status && Array.isArray(res.data.data)) {
          setAccounts(res.data.data);
        }
      } catch (err) {
        console.error("Failed to fetch expense accounts", err);
      }
    };
    fetchAccounts();
  }, []);

  // --- Fetch Payment Methods ---
  useEffect(() => {
    const fetchPaymentModes = async () => {
      try {
        const res = await api.get('/v1/income/get-payment-method');

        if (res.data && Array.isArray(res.data.data)) {
          setPaymentModes(res.data.data);
        } else {
          setPaymentModes([]);
        }
      } catch (err) {
        console.error("Error fetching payment methods:", err);
        setPaymentModes([]);
      }
    };
    fetchPaymentModes();
  }, []);

  // --- Fetch Currencies ---
  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const res = await api.get('/v1/fetch-all-currencies');

        if (res.data && Array.isArray(res.data.data)) {
          setCurrencyOptions(res.data.data);

          // ✅ Set NGN as default
          const ngnCurrency = res.data.data.find(c => c.code === "NGN");
          if (ngnCurrency) setSelectedCurrency(ngnCurrency.id);
        }
      } catch (err) {
        console.error("Error fetching currencies:", err);
      }
    };
    fetchCurrencies();
  }, []);

  useEffect(() => {
    const fetchCreditAccounts = async () => {
      setDebitAccountsLoading(true);
      try {
        const res = await api.get('/v1/bank-accounts');

        if (res.data && Array.isArray(res.data.data)) {
          const creditAccounts = res.data.data.map((acc) => ({
            value: acc.id,
            label: acc.gl_name || acc.name || acc.account_name,
          }));
          setCreditAccounts(creditAccounts);
        } else {
          setCreditAccounts([]);
        }
      } catch (error) {
        console.error("Error fetching credit accounts:", error);
        setCreditAccounts([]);
      } finally {
        setDebitAccountsLoading(false);
      }
    };

    if (isOpen) fetchCreditAccounts();
  }, [isOpen]);

  // NEW: lock background scroll only while modal is open
  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      // restore previous overflow when modal closes/unmounts
      document.body.style.overflow = prev || "";
    };
  }, [isOpen]);

  // Fetch states when modal opens and populate taxStations
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const res = await api.get('/v1/fetch-all-state');

        // Expecting an array at res.data.data
        const states = Array.isArray(res?.data?.data) ? res.data.data : [];
        setTaxStations(states);
      } catch (error) {
        console.error("Failed to fetch states:", error);
        setTaxStations([]);
      }
    };

    if (isOpen) fetchStates();
  }, [isOpen]);

  // Fetch employment types & statuses when modal opens
  useEffect(() => {
    if (!isOpen) return;
    const fetchEmploymentData = async () => {
      try {
        setEmploymentLoading(true);
        const [typesRes, statusRes] = await Promise.all([
          api.get('/v1/employee/employement_type'),
          api.get('/v1/employee/employement_status'),
        ]);

        setEmploymentTypes(Array.isArray(typesRes?.data?.data) ? typesRes.data.data : []);
        setEmploymentStatuses(Array.isArray(statusRes?.data?.data) ? statusRes.data.data : []);
      } catch (err) {
        console.error("Failed to fetch employment types/statuses:", err);
        setEmploymentTypes([]);
        setEmploymentStatuses([]);
      } finally {
        setEmploymentLoading(false);
      }
    };

    fetchEmploymentData();
  }, [isOpen]);

  // Fetch generated employee id when modal opens and set it (read-only)
  useEffect(() => {
    if (!isOpen) return;
    const fetchEmpId = async () => {
      try {
        const res = await api.get('/v1/employee/generate_number');
        // expect generated id in res.data.data or res.data.number - adjust if different
        const idFromApi = res?.data?.data || res?.data?.number || "";
        setGeneratedEmpId(String(idFromApi));
      } catch (err) {
        console.error("Failed to fetch generated employee id:", err);
        setGeneratedEmpId("");
      }
    };
    fetchEmpId();
  }, [isOpen]);

  // Fetch Grades
  useEffect(() => {
    const fetchGrades = async () => {
      try {
        setGradeLoading(true);
        const res = await api.get('/v1/get-grades');
        const grades = Array.isArray(res?.data?.data) ? res.data.data : [];
        setGradeOptions(grades);
      } catch (err) {
        console.error("Error fetching grades:", err);
        setGradeOptions([]);
      } finally {
        setGradeLoading(false);
      }
    };
    fetchGrades();
  }, []);

  // Fetch Pay Basis options
  useEffect(() => {
    const fetchPayBasis = async () => {
      try {
        setPayBasisLoading(true);
        const res = await api.get('/v1/payroll/get_pay_basis');
        const bases = Array.isArray(res?.data?.data) ? res.data.data : [];
        setPayBasisOptions(bases);
        // default to "Monthly" if available, else first option
        if (!payBasis) {
          const monthly = bases.find(b => (b.description || "").toLowerCase() === "monthly");
          if (monthly) setPayBasis(String(monthly.id));
          else if (bases[0]?.id) setPayBasis(String(bases[0].id));
        }
      } catch (err) {
        console.error("Error fetching pay basis:", err);
        setPayBasisOptions([]);
      } finally {
        setPayBasisLoading(false);
      }
    };
    fetchPayBasis();
  }, []);

  // Fetch Steps
  useEffect(() => {
    const fetchSteps = async () => {
      try {
        setStepLoading(true);
        const res = await api.get('/v1/get-steps');
        const steps = Array.isArray(res?.data?.data) ? res.data.data : [];
        setStepOptions(steps);
      } catch (err) {
        console.error("Error fetching steps:", err);
        setStepOptions([]);
      } finally {
        setStepLoading(false);
      }
    };
    fetchSteps();
  }, []);

  // Fetch Allowance Types (GET with description param)
  useEffect(() => {
    const fetchAllowanceTypes = async () => {
      try {
        setAllowanceTypesLoading(true);
        const res = await api.get('/v1/get-allowance-type', { params: { description: "" } });
        const types = Array.isArray(res?.data?.data) ? res.data.data : [];
        setAllowanceTypes(types);
      } catch (err) {
        console.error("Error fetching allowance types:", err);
        setAllowanceTypes([]);
      } finally {
        setAllowanceTypesLoading(false);
      }
    };
    fetchAllowanceTypes();
  }, []);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: String(value) }));
  };

  // Selected WHT state helpers
  const selectedWht = taxStations.find((s) => String(s.id_no) === String(formData.wht));
  const isOgunStateSelected = (selectedWht?.state || "").toLowerCase() === "ogun state";

  // NEW: save handler used by the embedded employee form (was referenced but missing)
  function handleSaveForm(e) {
    if (e && typeof e.preventDefault === "function") e.preventDefault();

    // gather values from DOM (keeps current approach)
    const first_name = document.getElementById('empFirstName')?.value?.trim() || "";
    const last_name = document.getElementById('empLastName')?.value?.trim() || "";
    const sex = document.getElementById('empGender')?.value || "";
    const employee_id = generatedEmpId || "";
    const home_address = document.getElementById('empAddress')?.value || "";
    const ninVal = document.getElementById('empNin')?.value?.trim() || "";
    const email = document.getElementById('empEmail')?.value || "";
    const phone_no = document.getElementById('empPhone')?.value || "";
    const dob = document.getElementById('empDob')?.value || "";
    const marital_status = document.getElementById('empMarital')?.value || "";
    const department = document.getElementById('empDept')?.value || "";
    const unit = document.getElementById('empUnit')?.value || "";
    const employment_type = document.getElementById('empType')?.value || "";
    const job_title = document.getElementById('empJobTitle')?.value || "";
    const grade = document.getElementById('empGrade')?.value || "";
    const step = document.getElementById('empStep')?.value || "";
    const date_of_first_appointment = document.getElementById('empAppointment')?.value || "";
    const manager_name = document.getElementById('empSupervisor')?.value || "";
    const employment_status = document.getElementById('empStatus')?.value || "";
    const bank_name = document.getElementById('empBank')?.value || "";
    const account_number = document.getElementById('empAccount')?.value || "";
    const basic_salary = document.getElementById('empSalary')?.value || "";
    const pension_number = document.getElementById('empPension')?.value || "";
    // use selected state id_no from formData.wht
    const state = formData.wht || "";
    const stin = formData.stin || "";
    const tax_agent = document.getElementById('empTaxAgent')?.value || ""; // read from the Tax Agent select
    const next_of_kin_name = document.getElementById('empKinName')?.value || "";
    const relationship = document.getElementById('empKinRel')?.value || "";
    const next_of_kin_phone = document.getElementById('empKinPhone')?.value || "";
    const next_of_kin_address = document.getElementById('empKinAddr')?.value || "";
    // photo: use verifiedNinImage (data URI or normalized URL) if present
    const photo = verifiedNinImage || "";

    // basic validation
    if (!first_name || !last_name || !employee_id) {
      Swal.fire({ icon: "error", title: "Missing data", text: "First name, last name and generated Employee ID are required." });
      return;
    }

    // build payload matching endpoint parameter names
    const payload = {
      first_name,
      last_name,
      sex,
      employee_id,
      home_address,
      nin: ninVal,
      email,
      phone_no,
      dob,
      marital_status,
      department,
      unit,
      employment_type,
      job_title,
      grade,
      step,
      date_of_first_appointment,
      manager_name,
      employment_status,
      bank_name,
      account_number,
      basic_salary,
      pension_number,
      state,
      stin,
      tax_agent,
      next_of_kin_name,
      relationship,
      next_of_kin_phone,
      next_of_kin_address,
      photo,
    };

    // send to server
    (async () => {
      setIsSaving(true);
      try {
        const res = await api.post('/v1/employee/add', withCompanyId(payload));

        // stop spinner before closing
        setIsSaving(false);

        // Close modal after request concluded
        if (typeof onClose === "function") onClose();

        // Show response via Swal (success or error)
        if (res?.data?.status) {
          Swal.fire({ icon: "success", title: "Saved", text: res.data.message || "Employee added successfully." });
        } else {
          Swal.fire({ icon: "error", title: "Error", text: res?.data?.message || "Failed to add employee." });
        }
      } catch (err) {
        // stop spinner, close modal, then show error
        setIsSaving(false);
        if (typeof onClose === "function") onClose();

        const msg = err?.response?.data?.message;
        if (msg && typeof msg === "object") {
          const combined = Object.values(msg).flat().join("; ");
          Swal.fire({ icon: "error", title: "Save failed", text: combined });
        } else {
          Swal.fire({ icon: "error", title: "Save failed", text: err?.response?.data?.message || "Could not save employee." });
        }
      }
    })();
  }

  // NEW: verify NIN endpoint call (uses component state) — switched to GET
  const verifyNin = async () => {
    const ninVal = (nin || "").trim();
    const fName = (firstName || "").trim();
    const lName = (lastName || "").trim();

    if (!ninVal || !fName || !lName) return;
    if (lastVerifiedNin && lastVerifiedNin === ninVal) return; // avoid duplicate

    setVerifyingNin(true);
    try {
      // use GET with query params via centralized api
      const res = await api.get('/v1/verify-nin', { params: { nin: ninVal, first_name: fName, last_name: lName } });

      const data = res?.data?.data || {};
      // prefer "picture" (URL) first for display, fallback to nested nin_info.photo (base64) if absent
      let chosenImage =
        data.picture ||
        (data?.nin_info && data.nin_info.photo) ||
        null;

      // If API returned a raw data string (rare), accept that as data-uri if it already starts so
      if (!chosenImage && typeof res?.data === "string" && res.data.startsWith("data:image")) {
        chosenImage = res.data;
      }

      if (chosenImage) {
        if (typeof chosenImage === "string") {
          // 1) Remove literal backslashes that may remain from escaping (e.g. "\/")
          chosenImage = chosenImage.replace(/\\+/g, "");
          // 2) Replace any remaining escaped slash sequences
          chosenImage = chosenImage.replace(/\\\//g, "/");
          // 3) Trim whitespace
          chosenImage = chosenImage.trim();
        }

        // Detect URL vs base64-like payload
        const looksLikeUrl = typeof chosenImage === "string" && /^(https?:\/\/|\/\/)/i.test(chosenImage);
        // Allow leading slashes ("/9j/...") in base64 payloads, strip them for testing
        const candidateForBase64Test = typeof chosenImage === "string" ? chosenImage.replace(/^\/+/, "") : "";
        const looksBase64Like = /^[A-Za-z0-9+/=\s]+$/.test(candidateForBase64Test) && candidateForBase64Test.length > 100;

        // If it appears to be base64 (raw image data), convert to data URI
        if (looksBase64Like && !looksLikeUrl) {
          const cleanedBase64 = candidateForBase64Test.replace(/\s+/g, "");
          chosenImage = `data:image/jpeg;base64,${cleanedBase64}`;
        } else {
          // Normalize URL: collapse accidental multiple slashes but preserve protocol ("https://")
          if (typeof chosenImage === "string") {
            // collapse duplicate slashes except after protocol (http(s):)
            chosenImage = chosenImage.replace(/(^|[^:])\/{2,}/g, "$1/");
            // If it's still a relative path (starts with '/'), prepend BASE_URL
            if (/^\//.test(chosenImage) && !/^\/\//.test(chosenImage)) {
              chosenImage = `${BASE_URL.replace(/\/$/, "")}${chosenImage}`;
            }
          }
        }

        // set image only — no Swal here (user requested alerts only on save)
        setVerifiedNinImage(chosenImage);
      } else {
        // no image, just rely on inline status — do not show Swal
        console.info("NIN verified but no image returned.", res?.data?.message);
      }

      setLastVerifiedNin(ninVal);
    } catch (err) {
      // don't show Swal here; log instead
      console.error("NIN verification failed:", err?.response?.data || err);
    } finally {
      setVerifyingNin(false);
    }
  };

  // AUTO: trigger verification when nin reaches 11 digits and names are present
  useEffect(() => {
    const cleaned = (nin || "").replace(/\D/g, ""); // digits only
    const requiredLength = 11;
    if (!firstName || !lastName) return;
    if (cleaned.length !== requiredLength) return;
    if (lastVerifiedNin === cleaned) return;
    // set NIN state to digits-only (optional)
    if (cleaned !== nin) setNin(cleaned);
    // small debounce
    const t = setTimeout(() => verifyNin(), 300);
    return () => clearTimeout(t);
  }, [nin, firstName, lastName, lastVerifiedNin]);

  if (!isOpen) return null;

  return (
    <div
      className={classes.modalOverlay}
      style={{ position: "fixed", inset: 0, overflow: "auto", zIndex: 9999, background: "rgba(0,0,0,0.4)" }}
    >
      <div>
        {/* REPLACED modal content with Salary Structure form */}
        <div
          className={classes.modalContent}
          style={{
            maxHeight: "90vh",
            overflowY: "auto",
            margin: "24px auto",
            maxWidth: 900,
            margin: "0 auto",
            padding: 24,
            borderRadius: 12,
            position: "relative"
          }}
        >
          {modalAlert && (
            <div
              style={{
                position: "absolute",
                top: 12,
                left: "50%",
                transform: "translateX(-50%)",
                background: modalAlert.type === "error" ? "#fee2e2" : "#d1fae5",
                color: modalAlert.type === "error" ? "#b91c1c" : "#065f46",
                border: `1px solid ${modalAlert.type === "error" ? "#fca5a5" : "#6ee7b7"}`,
                padding: "10px 16px",
                borderRadius: 8,
                zIndex: 2,
                minWidth: "60%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
              }}
            >
              <span>{modalAlert.message}</span>
              <button
                type="button"
                onClick={() => setModalAlert(null)}
                style={{ border: "none", background: "transparent", fontSize: 18, cursor: "pointer", color: "inherit" }}
              >
                ×
              </button>
            </div>
          )}

          <h2 style={{ textAlign: "center", color: "#1e293b", marginBottom: 8 }}>
            {isAllowanceMode ? "Set Allowances" : "Set Basic Salary"}
          </h2>

          <form
            id="structureForm"
            onSubmit={(e) => {
              e.preventDefault();
              saveStructure();
            }}
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: 16,
            }}
          >
            
            <div>
              <label>Grade</label>
              <select id="empGrade" defaultValue="">
                <option value="" disabled>{gradeLoading ? "Loading grades..." : "Select Grade"}</option>
                {gradeOptions.map((g) => (
                  <option key={g.id} value={g.id}>{g.description}</option>
                ))}
              </select>
            </div>
            <div>
              <label>Step</label>
              <select id="empStep" defaultValue="">
                <option value="" disabled>{stepLoading ? "Loading steps..." : "Select Step"}</option>
                {stepOptions.map((s) => (
                  <option key={s.id} value={s.id}>{s.description || s.name || `Step ${s.id}`}</option>
                ))}
              </select>
            </div>

            {!isAllowanceMode && (
              <div>
                <label>Job Title</label>
                <input type="text" id="jobTitle" placeholder="e.g. Accountant" value={jobTitle} onChange={(e) => setJobTitle(e.target.value)} />
              </div>
            )}

            <div>
              <label>Pay Basis</label>
              <select value={payBasis} onChange={(e) => setPayBasis(e.target.value)}>
                <option value="" disabled>{payBasisLoading ? "Loading pay basis..." : "Select Pay Basis"}</option>
                {payBasisOptions.map((p) => (
                  <option key={p.id} value={p.id}>{p.description}</option>
                ))}
              </select>
            </div>

            {!isAllowanceMode && (
              <div>
                <label>Basic Salary (₦)</label>
                <input type="number" id="basic" value={basic} min="0" step="0.01" onChange={(e) => setBasic(e.target.value)} />
              </div>
            )}

            {isAllowanceMode && (
              <>
                <div style={{ gridColumn: "1 / -1", marginTop: 20 }}>
                  <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 8, color: "#16A34A" }}>Allowances</div>
                  <div id="allowanceList" style={{ background: "#f8fafc", padding: 12, borderRadius: 6 }}>
                    {allowances.map((row, idx) => (
                      <div key={idx} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                        <div className={classes.allowanselecct}>
                          <label>Allowance Type</label>
                          <select
                            value={row.allowanceTypeId}
                            onChange={(e) => updateRow("allowance", idx, "allowanceTypeId", e.target.value)}
                            style={{ flex: 1 }}>
                            <option value="" disabled>{allowanceTypesLoading ? "Loading..." : "Select Allowance"}</option>
                            {allowanceTypes.map((t) => (
                              <option key={t.id} value={t.id}>{t.description || t.name}</option>
                            ))}
                          </select>
                        </div>

                        <div>
                          <label>Percentage</label>
                          <input
                            type="text"
                            placeholder="e.g. 10"
                            value={row.percentage === null ? "" : String(row.percentage)}
                            onChange={(e) => updateRow("allowance", idx, "percentage", e.target.value)}
                            style={{ width: 120 }}
                          />
                        </div>

                        <div>
                          <label>Amount</label>
                          <input
                            type="number"
                            placeholder="Amount"
                            value={row.amount === "" ? "" : row.amount}
                            min="0"
                            step="0.01"
                            onChange={(e) => updateRow("allowance", idx, "amount", e.target.value)}
                            style={{ width: 140 }}
                            readOnly={row.percentage !== "" && row.percentage !== null}
                          />
                        </div>

                        <div className={classes.dltbtn}>
                          <button type="button" className={classes.secondaryBtn} onClick={() => removeRow("allowance", idx)}>
                            ✕
                          </button>
                        </div>

                      </div>
                    ))}
                  </div>
                  <button type="button" className={classes.secondaryBtn} onClick={addAllowance} style={{ marginTop: 8 }}>
                    + Add Allowance
                  </button>
                </div>

                {inlineAlert ? (
                  <div style={{ gridColumn: "1 / -1", marginTop: 8 }}>
                    <div style={{ background: "#FEF3C7", border: "1px solid #F59E0B", color: "#92400E", padding: "10px 12px", borderRadius: 6, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span>{inlineAlert}</span>
                      <button type="button" onClick={() => setInlineAlert("")} style={{ background: "transparent", border: "none", color: "#92400E", cursor: "pointer", fontWeight: 600 }}>×</button>
                    </div>
                  </div>
                ) : null}
              </>
            )}

            {/* Deductions Section */}
            {/* <div style={{ gridColumn: "1 / -1", marginTop: 20 }}>
							<div style={{ fontWeight: 600, fontSize: 15, marginBottom: 8, color: "#16A34A" }}>Deductions</div>
							<div id="deductionList" style={{ background: "#f8fafc", padding: 12, borderRadius: 6 }}>
								{deductions.map((row, idx) => (
									<div key={idx} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
										<input
											type="text"
											placeholder="Deduction name (e.g. Tax)"
											value={row.name}
											onChange={(e) => updateRow("deduction", idx, "name", e.target.value)}
											style={{ flex: 1 }}
										/>
										<input
											type="number"
											placeholder="Amount"
											value={row.amount}
											min="0"
											step="0.01"
											onChange={(e) => updateRow("deduction", idx, "amount", e.target.value)}
											style={{ width: 140 }}
										/>
										<button type="button" className={classes.secondaryBtn} onClick={() => removeRow("deduction", idx)}>
											✕
										</button>
									</div>
								))}
							</div>
							<button type="button" className={classes.secondaryBtn} onClick={addDeduction} style={{ marginTop: 8 }}>
								+ Add Deduction
							</button>
						</div> */}

            {/* Actions */}
            <div style={{ gridColumn: "1 / -1", display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 20 }}>
              <button
                type="button"
                className={classes.primaryBtn}
                onClick={() => {
                  saveStructure();
                }}
                disabled={isSaving}
                style={{ backgroundColor: "#16A34A", color: "#fff", padding: "10px 16px", borderRadius: 6, opacity: isSaving ? 0.7 : 1, cursor: isSaving ? "not-allowed" : "pointer" }}
              >
                {isSaving ? (
                  <>
                    <Spinner animation="border" size="sm" role="status" aria-hidden="true" />{" "}
                    Processing...
                  </>
                ) : (
                  (isAllowanceMode ? "Save Allowances" : "Save Basic Salary")
                )}
              </button>
              <button
                type="button"
                className={classes.secondaryBtn}
                onClick={() => {
                  resetStructureForm();
                }}
                style={{ background: "#fff", border: "1px solid #cbd5e1", padding: "10px 16px", borderRadius: 6 }}
              >
                Reset
              </button>
            </div>
          </form>

          {/* keep existing modal close control */}
          <button className={classes.closeBtn} onClick={onClose}>
            ×
          </button>
        </div>
      </div>
    </div>
  );

  // ...existing code...
}

export default SalaryStructureSet;